import { useQuery } from '@tanstack/react-query';
import { ProjectOpportunityService } from '../../services/project-opportunity';
import { AxiosError } from 'axios';
import { IErrorResponse } from '../../interfaces/errorResponse';
import { parseAxiosError } from '../../services/axios';
import { IBaseUseQueryProps } from '../../interfaces/baseUseQueryProps';
import { IProjectOpportunity } from '../../interfaces/projectOpportunity';
import { useNotification } from '../../+state/useNotification';

interface IProps extends IBaseUseQueryProps<IProjectOpportunity> {
  clientId?: number,
  projectOpportunityId?: string,
}

export const GET_PROJECT_DETAILS_QUERY_KEY = 'get-project-details';

export const useGetProjectDetails = ({ clientId, projectOpportunityId, onError, ...props }: IProps) => {
  const { openErrorToast } = useNotification();
  return useQuery({
    queryKey: [GET_PROJECT_DETAILS_QUERY_KEY, clientId, projectOpportunityId],
    queryFn: () => ProjectOpportunityService.getProjectDetails({ clientId: +clientId!, projectOpportunityId: projectOpportunityId! }),
    enabled: !!clientId && !!projectOpportunityId,
    onError: (err: AxiosError<IErrorResponse>) => {
      openErrorToast(parseAxiosError(err));
      onError?.(err)
    },
    refetchOnWindowFocus: false,
    ...props
  });
};